import { NOTIFICATION_TYPES } from "./constants";

// Simple notification system - could be extended with toast libraries like react-hot-toast
class NotificationService {
  constructor() {
    this.notifications = [];
    this.listeners = [];
  }

  // Add a notification
  add(message, type = NOTIFICATION_TYPES.INFO, duration = 5000) {
    const notification = {
      id: Date.now(),
      message,
      type,
      timestamp: new Date(),
    };

    this.notifications.push(notification);
    this.notifyListeners();

    // Auto-remove after duration
    if (duration > 0) {
      setTimeout(() => {
        this.remove(notification.id);
      }, duration);
    }

    return notification.id;
  }

  // Remove a notification
  remove(id) {
    this.notifications = this.notifications.filter((n) => n.id !== id);
    this.notifyListeners();
  }

  // Clear all notifications
  clear() {
    this.notifications = [];
    this.notifyListeners();
  }

  // Subscribe to notification changes
  subscribe(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== callback);
    };
  }

  // Notify all listeners
  notifyListeners() {
    this.listeners.forEach((callback) => callback(this.notifications));
  }

  // Convenience methods
  success(message, duration) {
    return this.add(message, NOTIFICATION_TYPES.SUCCESS, duration);
  }

  error(message, duration) {
    return this.add(message, NOTIFICATION_TYPES.ERROR, duration);
  }

  warning(message, duration) {
    return this.add(message, NOTIFICATION_TYPES.WARNING, duration);
  }

  info(message, duration) {
    return this.add(message, NOTIFICATION_TYPES.INFO, duration);
  }
}

// Export singleton instance
export const notificationService = new NotificationService();

// Fallback to alert if notifications are not available
export const showNotification = (message, type = NOTIFICATION_TYPES.INFO) => {
  // For now, we'll use alert as fallback
  // In a real app, you'd integrate with a toast library
  if (type === NOTIFICATION_TYPES.ERROR) {
    alert(`❌ ${message}`);
  } else if (type === NOTIFICATION_TYPES.SUCCESS) {
    alert(`✅ ${message}`);
  } else if (type === NOTIFICATION_TYPES.WARNING) {
    alert(`⚠️ ${message}`);
  } else {
    alert(`ℹ️ ${message}`);
  }
};
